//import axios from 'axios';
import axios from '../utils/axios'
const API_URL = process.env.REACT_APP_API_URL + "/v1/admin/";

const getAllDoctors = (clinicid)=>{
    return axios.get(API_URL+"clinics/"+clinicid+"/bookings/doctors");
}
const getDoctorById = (clinicid,doctorid)=>{
    return axios.get(API_URL+"clinics/"+clinicid+"/bookings/doctors/"+doctorid);
}
const getDoctorHours  = (clinicid,doctorid)=>{
    return axios.get(API_URL+"clinics/"+clinicid+"/bookings/doctors/"+doctorid+"/hours");
}
const updateDoctorHours = (clinicid,doctorid,data)=>{
    return axios.put(API_URL+"clinics/"+clinicid+"/bookings/doctors/"+doctorid+"/hours",data);
}
const getCustomHours = (clinicid,doctorid,pageNo=0,pageSize=5)=>{
    return axios.get(API_URL+"clinics/"+clinicid+"/bookings/doctors/"+doctorid+"/custom-hours?pageNo="+pageNo+"&pageSize="+pageSize);
}
const addCutomHour = (clinicid,doctorid,data)=>{
    return axios.post(API_URL+"clinics/"+clinicid+"/bookings/doctors/"+doctorid+"/custom-hours",data)
}
const deleteCustomHour = (clinicid,doctorid,customHourId)=>{
//{{server_path}}/{{admin_path}}/clinics/{{eos_id}}//bookings/doctors/{{doctorId}}/custom-hours/{{customWorkingHoursId}}
    return axios.delete(API_URL+"clinics/"+clinicid+"/bookings/doctors/"+doctorid+"/custom-hours/"+customHourId)
}
const addUpdateDoctor = (clinicid,data)=>{
    return axios.post(API_URL+"clinics/"+clinicid+"/bookings/doctors",data)
}

const getApptTypeToDoctor = (clinicid,doctorid,userid)=>{
    return axios.get(API_URL+"clinics/"+clinicid+"/bookings/doctors/"+doctorid+"/"+userid+"/appt-types");
}
const deleteApptTypeToDoctor = (clinicid,doctorid,userid,data)=>{
    return axios.delete(API_URL+"clinics/"+clinicid+"/bookings/doctors/"+doctorid+"/"+userid+"/appt-types",{data:data});
}
const addUpdateApptTypeToDoctor = (clinicid,doctorid,userid,data)=>{
    return axios.post(API_URL+"clinics/"+clinicid+"/bookings/doctors/"+doctorid+"/"+userid+"/appt-types",data);
}
const getAllApptType = (clinicid)=>{
    return axios.get(API_URL+"clinics/"+clinicid+"/bookings/appt-types");
}
const addUpdateBookingType = (clinicid,data)=>{
    return axios.post(API_URL+"clinics/"+clinicid+"/bookings/appt-types",data)
}
const deleteBookingType= (clinicid,bookingtypeid) =>{
    return axios.delete(API_URL+"clinics/"+clinicid+"/bookings/appt-types/"+bookingtypeid)
}
export default {
    getAllDoctors,
    getDoctorById,
    getDoctorHours,
    updateDoctorHours,
    getCustomHours,
    addCutomHour,
    deleteCustomHour,
    addUpdateDoctor,
    getApptTypeToDoctor,
    deleteApptTypeToDoctor,
    addUpdateApptTypeToDoctor,
    getAllApptType,
    addUpdateBookingType,
    deleteBookingType
}